var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { addChain as walletAddChain, switchChain as walletSwitchChain, switchChainAndAddToken, useLiFiWalletManagement, } from '@lifi/wallet-management';
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useWidgetConfig } from '../WidgetProvider';
const stub = () => {
    throw new Error('You forgot to wrap your component in <WalletProvider>.');
};
const initialContext = {
    connect: stub,
    disconnect: stub,
    switchChain: stub,
    addChain: stub,
    addToken: stub,
    account: {},
};
const WalletContext = createContext(initialContext);
export const useWallet = () => useContext(WalletContext);
export const WalletProvider = ({ children }) => {
    const { walletManagement } = useWidgetConfig();
    const { connect: walletManagementConnect, disconnect: walletManagementDisconnect, signer, provider, } = useLiFiWalletManagement();
    const [account, setAccount] = useState({});
    const connect = useCallback((wallet) => __awaiter(void 0, void 0, void 0, function* () {
        if (walletManagement) {
            const signer = yield walletManagement.connect();
            const account = yield extractAccountFromSigner(signer);
            setAccount(account);
            return;
        }
        yield walletManagementConnect(wallet);
    }), [walletManagement, walletManagementConnect]);
    const disconnect = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (walletManagement) {
            yield walletManagement.disconnect();
            setAccount({});
            return;
        }
        yield walletManagementDisconnect();
    }), [walletManagement, walletManagementDisconnect]);
    // only for injected wallets
    const switchChain = useCallback((chainId) => __awaiter(void 0, void 0, void 0, function* () {
        if (walletManagement === null || walletManagement === void 0 ? void 0 : walletManagement.switchChain) {
            const signer = yield walletManagement.switchChain(chainId);
            const account = yield extractAccountFromSigner(signer);
            setAccount(account);
            return true;
        }
        return walletSwitchChain(chainId);
    }), [walletManagement]);
    const addChain = useCallback((chainId) => __awaiter(void 0, void 0, void 0, function* () {
        if (walletManagement === null || walletManagement === void 0 ? void 0 : walletManagement.addChain) {
            return walletManagement.addChain(chainId);
        }
        return walletAddChain(chainId);
    }), [walletManagement]);
    const addToken = useCallback((chainId, token) => __awaiter(void 0, void 0, void 0, function* () {
        if (walletManagement === null || walletManagement === void 0 ? void 0 : walletManagement.addToken) {
            return walletManagement.addToken(token, chainId);
        }
        return switchChainAndAddToken(chainId, token);
    }), [walletManagement]);
    // keep account information up to date
    useEffect(() => {
        const updateAccount = () => __awaiter(void 0, void 0, void 0, function* () {
            let account;
            if (walletManagement) {
                account = yield extractAccountFromSigner(walletManagement === null || walletManagement === void 0 ? void 0 : walletManagement.signer);
            }
            else {
                account = yield extractAccountFromSigner(signer);
            }
            setAccount(account);
        });
        updateAccount();
    }, [signer, walletManagement]);
    const value = useMemo(() => ({
        connect,
        disconnect,
        switchChain,
        addChain,
        addToken,
        account,
        provider,
    }), [account, addChain, addToken, connect, disconnect, provider, switchChain]);
    return (_jsx(WalletContext.Provider, Object.assign({ value: value }, { children: children })));
};
export const extractAccountFromSigner = (signer) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return {
            address: yield (signer === null || signer === void 0 ? void 0 : signer.getAddress()),
            isActive: (signer && !!(yield signer.getAddress()) === null) || !!signer,
            signer,
            chainId: yield (signer === null || signer === void 0 ? void 0 : signer.getChainId()),
        };
    }
    catch (error) {
        console.log(error);
        return {};
    }
});
